/** Hardcoded placeholders until question_budget_import_* keys exist in Språkhantering. */
export const BUDGET_IMPORT_TEXT = {
  button: 'Importera budget från Excel',
  title: 'Importera budget från Excel',
  intro:
    'Ladda upp er egen budgetfil (.xlsx). Vi läser av arbetsboken och föreslår värden för varje projektpart och år. Inget sparas förrän du har granskat och godkänt förslaget.',
  fileLabel: 'Excel-fil',
  fileHelp: 'Filformat: .xlsx eller .xlsm. Max 10 MB.',
  analyze: 'Analysera fil',
  reasoningLabel: 'Analysnivå',
  reasoningHelp:
    'Lägre nivå är snabbare, högre nivå hanterar röriga filer bättre.',
  reasoningNone: 'Ingen (snabbast, kräver gpt-5.1 eller nyare)',
  reasoningMinimal: 'Minimal',
  reasoningLow: 'Låg',
  reasoningMedium: 'Medel',
  reasoningHigh: 'Hög (långsammast)',
  modelLabel: 'AI-modell',
  modelHelp: 'Vilken Foundry-modell analysen ska köras mot.',
  loading: 'Läser av arbetsboken …',
  loadingSlow:
    'Analysen tar längre tid än vanligt. Röriga eller stora filer kräver mer tid – du kan vänta eller avbryta och prova en lägre analysnivå.',
  elapsed: 'Tid',
  cancelAnalyze: 'Avbryt analysen',
  error:
    'Det gick inte att läsa filen. Kontrollera att den är en giltig Excel-fil och försök igen.',
  unitLabel: 'Beloppen i filen anges i',
  unitSek: 'Kronor (SEK)',
  unitTkr: 'Tusentals kronor (tkr)',
  unitMsek: 'Miljoner kronor (MSEK)',
  unitHelp:
    'Kontrollera enheten – fel enhet ger tusen gånger för höga eller låga belopp.',
  includePart: 'Använd värden för denna projektpart',
  noValues: 'Inga värden hittades för denna projektpart.',
  current: 'Nuvarande',
  imported: 'Importerat',
  confidenceHigh: 'Hög konfidens',
  confidenceMedium: 'Medel konfidens',
  confidenceLow: 'Låg konfidens',
  source: 'Källa',
  unmatchedTitle: 'Delar av filen kunde inte kopplas',
  apply: 'Använd värden',
  cancel: 'Avbryt',
  chooseOther: 'Välj en annan fil',
  koordinator: 'Koordinator',
  kostnader: 'Kostnader',
  finansiering: 'Finansiering',
  orgnr: 'Org.nr',
  arbetsstalle: 'Arbetsställe',
  adress: 'Adress',
  soktBidrag: 'Sökt bidrag från Vinnova',
  preprocessingLabel: 'Förbehandla filen (filtrera på projekttid)',
  preprocessingHelp:
    'Vi läser av filens struktur, tar bort rader utanför projekttiden och summerar resten innan analysen. Snabbare och säkrare för stora transaktionslistor; stäng av om resultatet ser fel ut.',
} as const;

export const KOSTNADSSLAG_LABELS: Record<string, string> = {
  '1': 'Lönekostnader',
  '2': 'Utrustning, mark, byggnader',
  '3': 'Konsultkostnader, licenser',
  '4': 'Övriga direkta kostnader inkl. resor',
  '5': 'Indirekta kostnader',
};
